import PropTypes from 'prop-types';
import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';

import {FormWithButtons} from '@flexinet/ui-components';

import {NotificationSubscription} from '../types';
import {stage} from "../../../config/stage";
import {useModal} from "../../../hooks/useModal.ts";

export const RecordForm = ({
                               record,
                               handleSubmit,
                           }: {
    record: Omit<NotificationSubscription, 'id'>,
    handleSubmit: (values: NotificationSubscription) => void
}) => {
    const {closeModal} = useModal();

    const onSubmit = (values: NotificationSubscription) => {
        handleSubmit(values);
        closeModal();
    };

    const onCancel = () => {
        closeModal();
    };


    let initialValues = {} as NotificationSubscription;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent {...rest} />
                </FormWithButtons>)}
        </Formik>
    );
};

RecordForm.propTypes = {
    record: PropTypes.object,
    handleSubmit: PropTypes.func.isRequired,
};
